/**
 * Signature Maker — pure helpers (font list + filename). The canvas drawing and
 * PNG export are DOM-bound and live in the components; these bits are isolated
 * so they can be unit-tested.
 *
 * Fonts use system handwriting/script stacks (no external font requests — better
 * for privacy and performance). They always fall back to a generic family.
 */
export interface SignatureFont {
  id: string;
  name: string;
  /** CSS font-family stack (also used for canvas `ctx.font`). */
  family: string;
}

export const SIGNATURE_FONTS: SignatureFont[] = [
  {
    id: "casual",
    name: "Casual",
    family: "'Segoe Script', 'Bradley Hand', 'Comic Sans MS', cursive",
  },
  {
    id: "elegant",
    name: "Elegant",
    family:
      "'Snell Roundhand', 'Apple Chancery', 'Edwardian Script ITC', cursive",
  },
  {
    id: "brush",
    name: "Brush",
    family: "'Brush Script MT', 'Brush Script Std', cursive",
  },
  {
    id: "classic",
    name: "Classic",
    family: "'Lucida Calligraphy', Georgia, 'Times New Roman', serif",
  },
];

/** A safe download filename for the signature PNG, derived from the typed name. */
export function signatureFilename(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
  return slug ? `signature-${slug}.png` : "signature.png";
}

export function getFont(id: string): SignatureFont {
  return SIGNATURE_FONTS.find((f) => f.id === id) ?? SIGNATURE_FONTS[0];
}
